import { Device } from '@capacitor/device';
import checkCapacitorAndPluginsAvailable from '../helper-functions';

interface BatteryMetrics {
  /** Battery level from 0-100. */
  batteryLevel: number | null;
  batteryIsCharging: boolean | null;
}

const getCurrentBatteryLevelFunction = checkCapacitorAndPluginsAvailable(
  [],
  async (): Promise<BatteryMetrics> => {
    const { batteryLevel, isCharging } = await Device.getBatteryInfo();

    return {
      batteryLevel:
        Number.isNaN(batteryLevel) || batteryLevel === undefined
          ? null
          : batteryLevel * 100,
      batteryIsCharging: isCharging ?? null,
    };
  },
);

export const getCurrentBatteryLevelIfAvailable =
  (): Promise<BatteryMetrics> => {
    try {
      const output = getCurrentBatteryLevelFunction();
      if (!output) {
        throw new Error(`[battery.service] Failed to get battery info`);
      }
      return output;
    } catch (error) {
      // We don't care if it fails here, return null for the consumer to handle
      return Promise.resolve({
        batteryLevel: null,
        batteryIsCharging: null,
      });
    }
  };
